import { useTranslation } from '../../i18n';
import { DISCREET_TITLE, useDiscreet } from '../../security/discreet';

/** The product name in the active language, or the neutral "Notes" in discreet mode. */
export function useBrandName(): string {
  const { t } = useTranslation();
  const discreet = useDiscreet();
  return discreet ? DISCREET_TITLE : t('brand.name');
}
